var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n\t.st1{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M85.8,76.3c-1.8,0-2.5,0-5.4,0h-4.9c-0.4,0-0.7-0.2-1-0.5c-5-5.5-4.5-14.1,1.1-19 c5.6-4.9,14.1-4.4,19,1.1c4.5,5.1,4.5,12.8,0,17.9c-0.3,0.3-0.6,0.4-1,0.4h-5.1L85.8,76.3z M84.5,62.8c-0.1,0-0.2,0-0.3,0 c-2.2,0.2-3.9,2.1-3.7,4.4c0.2,2.2,2.1,3.9,4.4,3.7c2.1-0.2,3.7-1.9,3.7-4.1c0-0.4-0.1-0.8-0.2-1.2l2.4-1.7c0.6-0.4,0.7-1.3,0.3-1.9 c-0.2-0.3-0.5-0.5-0.9-0.5c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6,0.1-0.8,0.2l-2.4,1.8C86,63.1,85.3,62.8,84.5,62.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "dashboard_1_Background_Mask_",
    className: "st1",
    d: "M-0.5-0.5h51.1v51.1H-0.5V-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000098216619392461100380000016523658039347377548_",
    className: "st0",
    d: "M27.4,45.1c-3.3,0-4.6,0-9.8,0H8.6 c-0.7,0-1.3-0.4-1.8-0.9c-9.1-10-8.2-25.7,2-34.6s25.7-8,34.6,2c8.2,9.3,8.2,23.3,0,32.6c-0.5,0.5-1.1,0.7-1.8,0.7h-9.3L27.4,45.1z  M25,20.4c-0.2,0-0.4,0-0.5,0c-4,0.4-7.1,3.8-6.7,8c0.4,4,3.8,7.1,8,6.7c3.8-0.4,6.7-3.5,6.7-7.5c0-0.7-0.2-1.5-0.4-2.2l4.4-3.1 c1.1-0.7,1.3-2.4,0.5-3.5c-0.4-0.5-0.9-0.9-1.6-0.9c-0.2,0-0.2,0-0.4,0c-0.5,0-1.1,0.2-1.5,0.4l-4.4,3.3C27.7,21,26.5,20.4,25,20.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    className: "st0",
    d: "M25,29.6c-1.1,0-2.2-0.9-2.2-2.2c0-1.3,0.9-2.2,2.2-2.2s2.2,0.9,2.2,2.2l0,0 C27.2,28.6,26.1,29.6,25,29.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.1aa022bede9d1c8056b24eb68ab3b88e.svg";
export { ForwardRef as ReactComponent };